// docs: https://github.com/altostra/type-validations#readme
import { enumOf, objectOf } from "@altostra/type-validations";

export const isPostCompaniesCompanyIdEmailSelfServeIpPoolsResult = objectOf({
  data: objectOf({
    status: enumOf("PENDING" as const),
  }),
});
